module.exports = __webpack_public_path__ + "img/capa1.32ee04be.webp";